var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',{staticClass:"view-hero"}),_c('div',{staticClass:"router-view"},[_c('AddressLookupForm',{staticClass:"mx-auto max-w-md px-8 pb-6"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }